import { Select } from "@nextui-org/react";

export function CustomSelect({ label, selectElements = [], ...props }) {

    return (
        <Select
            label={label}
            className="max-w-xs"
            classNames={{
                base: "!max-w-none",
                label: "!text-primaryText",
                popoverContent: "text-primaryText font-semibold",
                value: "!text-primaryText font-semibold",
                trigger: "bg-white",
            }}
            listboxProps={{
                itemClasses: {
                    base: [
                        "rounded-md",
                        "transition-all",
                        "data-[hover=true]:!text-primaryText",
                        "data-[hover=true]:!font-bold",
                        "data-[hover=true]:!bg-lightBg",
                        "data-[pressed=true]:opacity-70",
                    ],
                }
            }}
            {...props}
        >
            {selectElements}
        </Select>
    )
}
